<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1 class="display font-weight-bold mb-3">ตรวจสอบข้อมูลบุคลากร</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3"> </v-col>
      <v-col cols="6">
        <div class="d-flex justify-center align-center">
          <v-text-field
            class="centered-input"
            label="กรุณาระบุรหัสบุคลากรหรือบัตรประจำตัวประชาชน"
            placeholder="ระบุเป็นตัวเลขติดกัน"
            outlined
            v-model="personInputId"
            type="number"
          ></v-text-field>
        </div>
        <div class="d-flex justify-center align-center">
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="green darken-4"
            dark
            @click="getPersonalData"
          >
            ตรวจสอบข้อมูล
          </v-btn>
        </div>
      </v-col>
      <v-col cols="3"> </v-col>
    </v-row>

    <v-row v-if="transactionData.length > 0">
      <v-col cols="12">
        <template>
          <v-card>
            <v-card-title>
              ประวัติการรับรักษา
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="transactionData"
              :loading="!transactionData.length"
              :search="search"
            >
              <template slot="progress">
                <v-progress-linear
                  color="green"
                  indeterminate
                ></v-progress-linear>
              </template>

              <template v-slot:[`item.timestamp`]="{ item }">
                {{ formatTimestamp(item.timestamp) }}
              </template>

              <template v-slot:[`item.cost`]="{ item }">
                {{ formatNumber(item.cost) }}
              </template>

              <!-- <template v-slot:[`item.actions`]="{ item }">
                <v-icon large color="yellow darken-2" @click="editItem(item)"
                  >mdi-pencil-outline
                </v-icon>

                <v-icon large color="red darken-2" @click="deleteItem(item)"
                  >mdi-close-circle
                </v-icon>
              </template> -->
            </v-data-table>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3"> </v-col>
      <v-col cols="6">
        <template class="sarabun">
          <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="green darken-4"
                  @click="editedIndex = -1"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  เพิ่มรายการรักษา
                </v-btn>
              </template>
              <v-card>
                <v-toolbar color="green darken-4" dark
                  >{{ formTitle }}รายละเอียดการรักษา</v-toolbar
                >

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            :items="patientLists"
                            label="เลือกผู้รับการรักษา"
                            v-model="editedItem.selectedPatient"
                            :rules="selectedPatientRule"
                          ></v-select>

                          <v-textarea
                            label="อาการ"
                            hint="กรอกตามใบรับรองแพทย์"
                            rows="3"
                            auto-grow
                            outlined
                            shaped
                            required
                            v-model="editedItem.symptom"
                            :rules="symptomRule"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            label="จำนวนเงินที่ใช้ไปตามสิทธิ์"
                            type="number"
                            hint="ไม่รวมเงินที่ชำระเองเพิ่มเติม"
                            required
                            v-model="editedItem.cost"
                            :rules="costRule"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            label="เลขที่ใบเสร็จ"
                            type="number"
                            required
                            v-model="editedItem.receiptNumber"
                            :rules="receiptNumberRule"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-4" dark @click="dialog = false">
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    color="green darken-4"
                    dark
                    :disabled="!valid"
                    @click="validate"
                  >
                    บันทึก
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-col>
      <v-col cols="3"> </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from "../store";
import {
  getFirestore,
  collection,
  query,
  where,
  doc,
  addDoc,
  setDoc,
  getDocs,
  Timestamp,
  onSnapshot,
  orderBy,
  // limit,
} from "firebase/firestore";

export default {
  data: () => ({
    editedItem: {},
    dialog: false,
    valid: true,
    editedIndex: -1,
    transactionData: [],
    personalData: {},
    personInputId: null,
    patientLists: ["บุตร", "คู่สมรส"],
    hospitalData: {},

    loader: null,
    loading: false,

    search: "",
    headers: [
      { text: "วันเวลา", value: "timestamp" },
      { text: "อาการ", value: "symptom" },
      { text: "จำนวนเงิน", value: "cost" },
      { text: "เลขที่ใบเสร็จ", value: "receiptNumber" },
      { text: "ผู้ใช้สิทธิ์", value: "selectedPatient" },
    ],
    // type: ["All", "Activity", "Shop"],
    // options: {},
    // selectedType: "All",

    selectedPatientRule: [(v) => !!v || "กรุณาเลือกผู้รับการรักษา"],
    symptomRule: [(v) => !!v || "กรุณาระบุอาการ"],
    costRule: [
      (v) => !!v || "กรุณาระบุจำนวนเงิน",
      (v) =>
        (v && v >= 0 && v <= 100000) ||
        "จำนวนเงินต้องมากกว่า 0 บาท แต่ไม่เกิน 100,000 บาท",
    ],
    receiptNumberRule: [
      (v) => !!v || "กรุณาระบุเลขที่ใบเสร็จ",
      (v) =>
        (v && v.length > 3 && v >= 0) || "เลขที่ใบเสร็จต้องมีมากกว่า 3 หลัก",
    ],
    db: getFirestore(),
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex == -1) {
          this.createItem();
        } else {
          this.updateItem();
        }
        this.close();
      } else {
        console.log("Form validation fail");
      }
    },
    async createItem() {
      this.editedItem.personId = "3140100311460";
      this.editedItem.timestamp = Timestamp.fromDate(new Date());
      this.editedItem.hospitalName = this.hospitalData.name;
      this.editedItem.cost = parseFloat(this.editedItem.cost);

      // await setDoc(doc(this.db, "bmiTable", "id"), this.editedItem);

      const docRef = await addDoc(
        collection(this.db, "transaction"),
        this.editedItem
      );
      console.log("Document written with ID: ", docRef.id);
    },

    async getPersonalData() {
      this.loader = "loading";
      this.personalData.personId = "3140100311460";
      this.getTransaction();
    },

    async getTransaction() {
      let q;

      q = query(
        collection(this.db, "transaction"),
        where("personId", "==", this.personalData.personId),
        orderBy("timestamp", "desc")
        // limit(3)
      );

      onSnapshot(q, (querySnapshot) => {
        this.transactionData = [];
        // var tmp = {};
        querySnapshot.forEach((doc) => {
          // tmp = Object.assign({ uid: doc.id }, doc.data());
          // (tmp.date = new Date(tmp.date.toDate()).toISOString().substr(0, 10)),
          this.transactionData.push(doc.data());
        });
      });
    },

    async getHospitalData() {
      const q = query(
        collection(this.db, "hospitaluser"),
        where("email", "==", store.user.email)
      );

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        // console.log(doc.id, " => ", doc.data());
        this.hospitalData = doc.data();
      });
    },

    async updateItem() {
      // console.log(this.editedItem);
      this.editedItem.bmi = parseInt(this.editedItem.bmi);
      this.editedItem.date = Timestamp.fromDate(new Date(this.editedItem.date));
      await setDoc(
        doc(this.db, "transactionData", this.editedIndex),
        this.editedItem
      );
      // console.log("Update");
      // Object.assign(this.transactionData[this.editedIndex], this.editedItem);
      // localStorage.setItem("bmi", JSON.stringify(this.transactionData));
    },

    formatTimestamp(t) {
      if (t instanceof Date) {
        return t;
      } else if (t == undefined) {
        return t;
      } else {
        return t.toDate().toLocaleString("th-TH", { timeZone: "Asia/Bangkok" });
      }
    },

    formatNumber(t) {
      if (t instanceof Number) {
        return t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return t;
      }
    },

    close() {
      this.dialog = false;
    },
  },
  watch: {},
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่ม" : "แก้ไข";
    },
  },
  async mounted() {
    this.getHospitalData();
    // await this.getTransaction();
  },
};
</script>

<style>
.centered-input.v-text-field .v-label {
  left: 50% !important;
  transform: translateX(-50%);
  transform-origin: top 50%;
}
.centered-input.v-text-field .v-label--active {
  left: 0% !important;
  transform: translateY(-25px) scale(0.75) translateX(0px);
}
</style>
